"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var EnqueueAction;
(function (EnqueueAction) {
    EnqueueAction.ON_ENQUEUE = 'ON_ENQUEUE';
    EnqueueAction.ON_ENQUEUE_DONE = 'ON_ENQUEUE_DONE';
    EnqueueAction.enqueue = typesafe_actions_1.createAction(EnqueueAction.ON_ENQUEUE, function (resolve) {
        return function (taskId, fn, args) { return resolve({ taskId: taskId, fn: fn, args: args }); };
    });
    EnqueueAction.enqueueDone = function (taskId, response) {
        return ({ type: EnqueueAction.ON_ENQUEUE_DONE + "_" + taskId, payload: response });
    };
})(EnqueueAction || (EnqueueAction = {}));
exports.default = EnqueueAction;
